import { inRange } from 'lodash';

const HEADER_SELECTOR = '.panel-header';
const BODY_SELECTOR = '.panel-body';

export const CONTEXT_LIST_TYPE_SINGLE = 'single';
export const CONTEXT_LIST_TYPE_MULTIPLE = 'multiple';
export const CONTEXT_LIST_TYPE_MULTIPLE_INVERT = 'multiple-invert';

export default class SettingsContextPanelController {
  static $inject = ['$element'];

  context: string;
  onDismiss: () => void;
  onUpdate: ($args: { $selected: Array<string>; $context: string }) => void;
  listAvailable: Array<string>;
  listSelected: Array<string>;
  listType: string;
  panelHeight: number;
  enabled = false;
  filterEnabled = false;
  filterPattern = '';
  filterOptions = {
    debounce: 100,
  };

  CONTEXT_LIST_TYPE_SINGLE = CONTEXT_LIST_TYPE_SINGLE;
  CONTEXT_LIST_TYPE_MULTIPLE = CONTEXT_LIST_TYPE_MULTIPLE;
  CONTEXT_LIST_TYPE_MULTIPLE_INVERT = CONTEXT_LIST_TYPE_MULTIPLE_INVERT;

  constructor(private $element) {}

  $onInit = () => {
    this.restrictScrollingToPanel();
  };

  /**
   * @todo make this a mixin because it's duplicated in `cell-select.plugin.ts`
   * @returns {any}
   */
  restrictScrollingToPanel() {
    const handleScroll = function (e) {
      const $this = $(this);
      const deltaY = e.originalEvent.deltaY;
      const bottomBoundary = $this.get(0).scrollHeight - $this.innerHeight();

      // prevent parent from scrolling
      if (deltaY < 0 && $this.scrollTop() === 0) {
        e.preventDefault();
      } else if (deltaY > 0 && $this.scrollTop() === bottomBoundary) {
        e.preventDefault();
      }
    };

    return this.$element.find(BODY_SELECTOR).on('wheel', handleScroll);
  }

  dismiss($event: angular.IAngularEvent) {
    $event.preventDefault();
    if (this.onDismiss) {
      this.onDismiss();
    } else {
      this.enabled = false;
    }
    // clean up state
    this.filterPattern = '';
  }

  /**
   * @param type {string|Array<string>}
   * @returns {boolean}
   */
  isListType(type: string | Array<string>) {
    if (Array.isArray(type)) {
      return type.indexOf(this.listType) >= 0;
    } else {
      return this.listType === type;
    }
  }

  isListTypeMultiple() {
    return this.isListType([CONTEXT_LIST_TYPE_MULTIPLE, CONTEXT_LIST_TYPE_MULTIPLE_INVERT]);
  }

  /**
   * @param item
   * @returns {boolean}
   */
  isSelected(item: string) {
    if (this.listType === CONTEXT_LIST_TYPE_MULTIPLE_INVERT) {
      return this.listSelected.indexOf(item) === -1;
    } else {
      return this.listSelected.indexOf(item) >= 0;
    }
  }

  isAllSelected() {
    if (this.listType === CONTEXT_LIST_TYPE_MULTIPLE_INVERT) {
      return this.listSelected.length === 0 && this.listAvailable.length;
    } else {
      return this.listAvailable.length === this.listSelected.length;
    }
  }

  isPartiallySelected() {
    const start = 1;
    const end = this.listAvailable.length;
    const selected = this.listSelected.length;

    return inRange(selected, start, end);
  }

  getPanelHeight(): number {
    return this.enabled ? this.panelHeight : 0;
  }

  toggleSelection(item) {
    this.listSelected = toggleListItem(this.listSelected, item);
    this.onUpdate({ $selected: this.listSelected, $context: this.context });
  }

  toggleAllSelection() {
    if (this.isAllSelected() || this.isPartiallySelected()) {
      this.unselectAll();
    } else {
      this.selectAll();
    }
    this.onUpdate({ $selected: this.listSelected, $context: this.context });
  }

  handleSelectAllClick($event: Event) {
    // prevent blocked/deselected checkbox from being checked
    if (this.isPartiallySelected()) {
      $event.preventDefault();
    }
    // toggle all checkboxes
    this.toggleAllSelection();
  }

  unselectAll() {
    if (this.listType === CONTEXT_LIST_TYPE_MULTIPLE_INVERT) {
      this.listSelected = this.listAvailable.slice();
    } else {
      this.listSelected = [];
    }
  }

  selectAll() {
    if (this.listType === CONTEXT_LIST_TYPE_MULTIPLE_INVERT) {
      this.listSelected = [];
    } else {
      this.listSelected = this.listAvailable.slice();
    }
  }

  setSelection(item) {
    this.onUpdate({ $selected: [item], $context: this.context });
  }

  itemValue(item) {
    return item.value || item;
  }

  itemDisplayName(item) {
    return item.displayName || item;
  }
}

function toggleListItem(list: string[], item: string): string[] {
  const index = list.indexOf(item);
  const result = list.slice();

  if (index >= 0) {
    result.splice(index, 1);
  } else {
    result.push(item);
  }

  return result;
}
